import React from "react";
import PropTypes from "prop-types";
import Markdown from 'markdown-to-jsx';
import { browserHistory } from "react-router";
import CommentActionLabel from "./commentActionLabel";
import CommentForm from "./commentForm";
import Popup from "../popup"
import * as resolutionProposalActionTypes from './commentResolutionProposalActionTypes';
import CommentResolutionProposalAction from './CommentResolutionProposalAction';
import dateUtil from "../../common/date/dateUtil";
import translate from "react-i18next/dist/commonjs/translate";
import * as commentTypes from './commentTypes';

class IncidentsComment extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            animateBadge: false,
            isActive: true,
            nextAction: null,
            value: '',
            isFormVisible: false,
            commentType: ''
        };

        this.handleClick = this.handleClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.redirectToSupportPage = this.redirectToSupportPage.bind(this);
        this.sleep = this.sleep.bind(this);
    }

    componentWillUpdate(nextProps, nextState) {
        if (nextProps.commentType !== this.props.commentType) {
            this.setState({ animateBadge: true, isActive: true, nextAction: null });
        }
    }

    handleClick(nextAction, nextCommentType) {
        const { incidentId, commentId } = this.props;
        if (nextAction === resolutionProposalActionTypes.REQUEST_FOR_INFORMATION || nextAction === resolutionProposalActionTypes.IMPLEMENTED || nextAction === resolutionProposalActionTypes.REJECTED || nextAction === resolutionProposalActionTypes.COMMENT_FROM_CUSTOMER) {
            this.setState(state => ({
                isActive: true,
                nextAction: nextAction,
                isFormVisible: true,
                commentType: nextCommentType
            }));
        }
        else {
            if (this.state.isActive) this.props.addResolutionProposalAction(incidentId, commentId, nextAction, nextCommentType);
            this.setState(state => ({
                isActive: false,
                nextAction: nextAction
            }));
        }
    }

    handleChange(e) {
        var value = (e.target.value) ? e.target.value.replace(/[^_.,!"'åäöüÅÄÖÜß0-9a-zA-Z-?~`<>@#$^&*();+=:{}[]\s]+/ig, "") : '';
        value = value.slice(0, 512)
        this.setState({ value: value });
    }
    handleSubmit(event) {
        const { incidentId, commentId } = this.props;
        let comment = this.state.value.replace(/[^_.,!"'åäöüÅÄÖÜß0-9a-zA-Z-?~`<>@#$^&*();+=:{}[]\s]+/ig, "");        
        comment = comment.slice(0, 512)
        this.setState({
            value: comment
        }, () => {
            if (this.state.nextAction == resolutionProposalActionTypes.REQUEST_FOR_INFORMATION) {
                this.props.addComment(incidentId, this.state.value, commentTypes.COMMENT_FROM_CUSTOMER)
            } else {
                if (this.state.value == '') {
                    this.props.addResolutionProposalAction(incidentId, commentId, this.state.nextAction, this.state.commentType);
                } else {
                    new Promise((resolve) => resolve(this.props.addComment(incidentId, this.state.value, commentTypes.COMMENT_FROM_CUSTOMER)))
                        .then(() => {
                            this.sleep(4000).then(() => {
                                this.props.addResolutionProposalAction(incidentId, commentId, this.state.nextAction, this.state.commentType);
                            });

                        });
                }
            }
        });

        this.setState(state => ({
            //isActive: false,
            //nextAction: this.state.nextAction,
            isFormVisible: false
        }));
        event.preventDefault();
    }
    sleep(time) {
        return new Promise((resolve) => setTimeout(resolve, time));
    }
    redirectToSupportPage(event) {
        const { incidentId, commentId } = this.props;
        browserHistory.push(
            `${global.applicationPath}/support`
        );
    }
    render() {
        const { date, status, user, incidentId, comment, commentType, isLatest, latestAction, t } = this.props;
        return (
            <li>

                <div className="timeline-badge user">
                    {user.substring(0, 2)}
                </div>
                <div className="timeline-panel">
                    <div className="timeline-heading">
                        <h4 className="timeline-title">
                            {user}

                            <span className="commentDate"><i className="fa fa-clock-o" />{`${dateUtil.toHourAndDay(date)}`}</span>
                        </h4>
                        <label className="badge commentType">{t(commentType)}</label>
                        <CommentActionLabel animate={this.state.animateBadge} commentTypeLabel={commentType} />
                    </div>
                    <div className="timeline-body">
                        {
                            (commentType !== commentTypes.RESOLUTION_PROPOSAL && commentType !== commentTypes.COMMENT_TO_CUSTOMER) && <Markdown className="timeline-comment" options={{ forceBlock: true }}>{comment}</Markdown>
                        }
                        {
                            this.state.isFormVisible && <CommentForm nextAction={this.state.nextAction} value={this.state.value} onSubmit={this.handleSubmit} onChange={this.handleChange} />
                        }
                        {
                            (isLatest && status !== resolutionProposalActionTypes.CLOSED && (latestAction !== commentTypes.RESOLUTION_PROPOSAL_IMPLEMENTED && latestAction !== commentTypes.RESOLUTION_PROPOSAL_REJECTED)) && <CommentResolutionProposalAction animate={this.state.animateBadge} nextAction={this.state.nextAction} onClick={this.handleClick} isActive={this.state.isActive} commentTypeLabel={commentType} />
                        }
                    </div>
                </div>
                <Popup incidentId={incidentId} redirectToSupportPage={this.redirectToSupportPage}></Popup>
            </li>);
    }
}
IncidentsComment.propTypes = {
    addResolutionProposalAction: PropTypes.func.isRequired,
    updateCommentType: PropTypes.func.isRequired,
    addComment: PropTypes.func.isRequired,
    onSubmit: PropTypes.func,
    comment: PropTypes.string,
    commentId: PropTypes.number.isRequired,
    commentType: PropTypes.string,
    date: PropTypes.string.isRequired,
    incidentId: PropTypes.number.isRequired,
    user: PropTypes.string.isRequired
};

export default translate("translations")(IncidentsComment);



// WEBPACK FOOTER //
// ./src/incidents/comments/incidentsComment.js